/** * * Asynchronously loads the component for
SIMSwap
* */ import { lazyLoad } from "utils/loadable";
export const SIMSwap = lazyLoad(
  () => import("./index"),
  (module) => module.SIMSwap
);
